
import {
  Component, PropSync, Prop, Ref, Mixins,
} from 'vue-property-decorator';
import AddPartInputs from '@/features/shipment/components/commercialInvoice/AddPartInputs.vue';
import { PartItem } from '@/features/shipment/types';
import { VForm } from '@/features/common/types';
import eventBus from '@/features/common/eventBus';
import eventNames from '@/features/common/constants/events';
import focusMixin from '@/features/common/mixins/focusMixin';
import { createPartsBook } from '../../services/parts-book.services';

@Component({
  components: {
    AddPartInputs,
  },
})
export default class EditPartsItem extends Mixins(focusMixin) {
  @Ref('editPartForm') form!: VForm;

  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) item!: PartItem & { index?: number };

  private data = { ...this.item };

  private submit(): void {
    const isValid = this.form.validate();
    if (!isValid) return;

    this.$emit('update', this.data);
    this.syncedShow = false;
  }

  private async savePartsBookItem(itemData: PartItem) {
    const isValid = this.form.validate();

    if (!isValid) {
      return true;
    }

    const response = await createPartsBook(itemData);
    return response;
  }

  private addToPartsBook = (partsBookResponse: PartItem | boolean) => {
    eventBus.$emit(eventNames.ADD_PARTS_BOOK_ITEM, partsBookResponse);
  }
}
